import './scrollTrigger';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import bp from '../../../apps/json/breakpoints.json';
import _debounce from 'lodash/debounce';
import { isMobileBrowser } from './_utils';

const baseClass = 'BodySection';
const classes = {
	pinSpacer: 'pin-spacer',
	bodySectionDark: 'BodySection--dark',
	bodySectionLight: 'BodySection--light',
	pininsm: 'pinin-sm',
	pininmd: 'pinin-md',
	pininlg: 'pinin-lg',
	pinoutsm: 'pinout-sm',
	pinoutmd: 'pinout-md',
	pinoutlg: 'pinout-lg',
	tabbed: 'tabbed',
};
const selectors = {
	base: `.${baseClass}`,
	pininsm: '.pinin-sm',
	pininmd: '.pinin-md',
	pininlg: '.pinin-lg',
	pinoutsm: '.pinout-sm',
	pinoutmd: '.pinout-md',
	pinoutlg: '.pinout-lg',
	pinSpacer: `.${classes.pinSpacer}`,
	alertBanner: '.AlertBanner',
	stickyFooter: '.Navigation-sticky-footer',
	stickyHeader: '.Navigation-sm.nav-sm.is-Stick',
};
window.ScrollTrigger = ScrollTrigger;
const setupSectionStyles = (sections, remove) => {
	if (sections) {
		sections.forEach(section => {
			const parentIsPin = section.parentElement.classList.contains(classes.pinSpacer);
			if (!parentIsPin) {
				section.style.position = remove ? '' : 'relative';
				section.style.zIndex = remove ? '' : '1';
			}
		});
		$('footer').css({
			position: remove ? '' : 'relative',
			'z-index': remove ? '' : 1,
		});
		$('#main').css({
			position: remove ? '' : 'relative',
			'z-index': remove ? '' : 1,
		});
	}
};

export default function bodySection() {
	let scrollTriggers = [];
	ScrollTrigger.saveStyles(selectors.base);
	// Options for the observer (which mutations to observe)
	const observerConfig = { childList: true, subtree: true, attributeFilter: ['class'] };

	// Callback function to execute when mutations are observed
	const observerCallback = _debounce(
		(mutationList, observer) => {
			window.requestAnimationFrame(() => {
				scrollTriggers.forEach(st => {
					st.refresh();
				});
			});
		},
		500,
		{ leading: false, trailing: true }
	);
	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(observerCallback);

	const setupSiblingPin = (section, i, createPin, offset) => {
		let siblingElement = section.previousElementSibling;
		if (section.parentElement && section.parentElement.classList.contains(classes.pinSpacer)) {
			siblingElement = section.parentElement.previousElementSibling;
			if (!siblingElement) {
				siblingElement = section.parentElement.parentElement.previousElementSibling;
			}
		}
		if (siblingElement && !siblingElement.classList.contains(classes.pinSpacer)) {
			siblingElement.style.zIndex = 2;
			siblingElement.style.position = 'relative';
			if (createPin) {
				//for some reason some mobile browsers end up with the wrong z index
				document.head.appendChild(
					document.createElement('style')
				).innerHTML = `.pin-spacer-pinin${i}-sibling {z-index: 2!important;}`;
				return ScrollTrigger.create({
					id: `pinin${i}-sibling`,
					trigger: siblingElement,
					start: () => {
						return `bottom bottom-=${offset + section.offsetHeight}`;
					},
					end: () => {
						return `bottom+=${section.offsetHeight} bottom-=${
							offset + section.offsetHeight
						}`;
					},
					pin: true,
					pinSpacing: false,
					anticipatePin: 1,
				});
			}
		}
	};
	const isMobile = isMobileBrowser();
	const setupSection = (section, inClass, outClass, i) => {
		let currTranslateY = 0;
		let prevViewportHeightDifference = 0;
		let lastRefreshHeight = window.innerHeight;
		const hasInPin = section.classList.contains(inClass);
		const hasOutPin = section.classList.contains(outClass);
		let stickyFooter;
		let stickyHeader;
		if (hasInPin || hasOutPin) {
			const images = section.querySelectorAll('img[loading="lazy"]');
			images.forEach(image => image.setAttribute('loading', 'eager'));

			stickyFooter = document.querySelector(selectors.stickyFooter);
			stickyHeader = document.querySelector(selectors.stickyHeader);
		}
		let innerSt;
		const onUpdate = ({ progress }) => {
			const offset =
				stickyFooter && stickyFooter.offsetHeight ? stickyFooter.offsetHeight : 0;
			const headerHeight =
				stickyHeader && stickyHeader.offsetHeight ? stickyHeader.offsetHeight : 0;
			const innerHeight = window.visualViewport
				? window.visualViewport.height
				: window.innerHeight;
			const visibleArea = innerHeight - offset - headerHeight;
			const progTarget = hasInPin ? 0.25 : -1;
			if (hasOutPin && section.offsetHeight < visibleArea && progress > progTarget) {
				if (!innerSt) {
					innerSt = setupSiblingPin(section, i, true, offset);
				}
			}

			let translateY = currTranslateY;
			// if the pinned area is bigger than the visible viewport need to show bottom before next component scrolling in
			if (hasInPin && hasOutPin && section.offsetHeight > visibleArea) {
				progress =
					progress < 0.5
						? 4 * progress * progress * progress
						: 1 - Math.pow(-2 * progress + 2, 3) / 2;
				const progressTranslate = (section.offsetHeight - visibleArea) * (1 - progress);
				translateY = (section.offsetHeight - progressTranslate) * -1;
				prevViewportHeightDifference = 0;
			}
			if (window.visualViewport && isMobile) {
				const viewportHeightDifference = lastRefreshHeight - window.visualViewport.height;
				if (viewportHeightDifference !== prevViewportHeightDifference) {
					translateY -= viewportHeightDifference - prevViewportHeightDifference;
					prevViewportHeightDifference = viewportHeightDifference;
					if (innerSt) {
						innerSt.trigger.style.transform = `translate(0px, ${
							viewportHeightDifference * -1
						}px)`;
					}
				}
			}
			if (translateY !== currTranslateY) {
				currTranslateY = translateY;
				section.style.transform = `translate(0px, ${translateY}px)`;
			}
		};
		let st;
		if (hasInPin) {
			const onEnter = () => {
				let offset = window.innerHeight;
				if (hasOutPin || section.offsetHeight < window.innerHeight) {
					offset = section.offsetHeight;
					if (hasOutPin) {
						setupSiblingPin(section, i, false);
					}
				}
				currTranslateY = offset * -1;
				section.style.transform = `translate(0px, ${currTranslateY}px)`;
				prevViewportHeightDifference = 0;
				onUpdate({
					progress: st.progress,
				});
			};
			const onLeave = () => {
				currTranslateY = 0;
				section.style.transform = `translate(0px, ${currTranslateY}px)`;
			};

			st = ScrollTrigger.create({
				id: `pinin${i}`,
				trigger: section,
				start: () => {
					const offset =
						stickyFooter && stickyFooter.offsetHeight ? stickyFooter.offsetHeight : 0;

					return `top bottom-=${offset}`;
				},
				end: () => {
					const offset =
						stickyFooter && stickyFooter.offsetHeight ? stickyFooter.offsetHeight : 0;
					if (hasOutPin) {
						return `bottom top-=${offset}`;
					} else if (window.innerHeight < section.offsetHeight) {
						return `top+=${window.innerHeight} bottom-=${offset}`;
					} else {
						return `bottom bottom-=${offset}`;
					}
				},
				pin: true,
				pinSpacing: false,
				anticipatePin: 2,
				onEnter,
				onEnterBack: onEnter,
				onLeave,
				onLeaveBack: onLeave,
				onUpdate,
				onRefresh: ({ isActive }) => {
					lastRefreshHeight = window.innerHeight;
					if (isActive) {
						onEnter();
					} else {
						currTranslateY = 0;
						section.style.transform = `translate(0px, ${currTranslateY}px)`;
					}
					if (innerSt) {
						innerSt.refresh();
					}
				},
			});
		} else if (hasOutPin) {
			const onEnter = () => {
				setupSiblingPin(section, i, false);
				onUpdate({
					progress: st.progress,
				});
			};
			st = ScrollTrigger.create({
				id: `pinout${i}`,
				trigger: section,
				start: () => {
					const offset =
						stickyFooter && stickyFooter.offsetHeight ? stickyFooter.offsetHeight : 0;
					return `bottom+=${offset} bottom`;
				},
				end: () => {
					return `bottom+=${window.innerHeight} top`;
				},
				pin: true,
				pinSpacing: false,
				onEnter,
				onEnterBack: onEnter,
				onUpdate,
				onRefresh: () => {
					lastRefreshHeight = window.innerHeight;
					if (innerSt) {
						innerSt.refresh();
					}
				},
			});
		}
		if (st) {
			if (window.visualViewport) {
				window.visualViewport.addEventListener('resize', () => {
					if (st.isActive) {
						onUpdate({
							progress: st.progress,
						});
					}
				});
			}
			scrollTriggers.push(st);
			observer.observe(section, observerConfig);
		}
		return st;
	};
	const sections = document.querySelectorAll(selectors.base);
	ScrollTrigger.matchMedia({
		[`(max-width: ${Number.parseInt(bp.breakpoints.md.replace('px', '')) - 1}px)`]: () => {
			scrollTriggers = [];
			observer.disconnect();
			sections.forEach((section, i) => {
				setupSection(section, classes.pininsm, classes.pinoutsm, i);
			});
			setupSectionStyles(sections, scrollTriggers.length === 0);
		},
		[`(min-width: ${bp.breakpoints.md}) and (max-width: ${
			Number.parseInt(bp.breakpoints.lg.replace('px', '')) - 1
		}px)`]: () => {
			scrollTriggers = [];
			observer.disconnect();
			sections.forEach((section, i) => {
				setupSection(section, classes.pininmd, classes.pinoutmd, i);
			});
			setupSectionStyles(sections, scrollTriggers.length === 0);
		},
		[`(min-width: ${bp.breakpoints.lg})`]: () => {
			scrollTriggers = [];
			observer.disconnect();
			sections.forEach((section, i) => {
				setupSection(section, classes.pininlg, classes.pinoutlg, i);
			});
			setupSectionStyles(sections, scrollTriggers.length === 0);
		},
	});

	//Tabbing fixes
	window.addEventListener(
		'focus',
		() => {
			// make sure active element is in view
			const $parentIsPin = $(document.activeElement).parents(selectors.pinSpacer);
			if ($parentIsPin && $parentIsPin.length) {
				const pinTop = $parentIsPin[0].getBoundingClientRect().top;
				const topTarget = document.activeElement.getBoundingClientRect().top - 100;
				if (pinTop < 0 || pinTop > topTarget) {
					const scrollY = window.scrollY + pinTop - topTarget;
					window.scrollTo(window.scrollX, scrollY);
				}
			}
		},
		true
	);
	//make sure refreshing doesn't break active element
	let currActiveElement;
	ScrollTrigger.addEventListener('refreshInit', () => {
		currActiveElement = document.activeElement;
	});
	ScrollTrigger.addEventListener('refresh', () => {
		if (currActiveElement) {
			currActiveElement.focus();
		}
	});
}
